module.exports = __webpack_public_path__ + "static/img/nodata.5b4f0bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nodata.png
// module id = f0hK
// module chunks = 36